import { EditFlowDetail } from 'app/core/store/edit-flow-detail/flow-detail.interface';
import { initialStateEditFlorderDetail, initialStateFlowDetail } from '../edit-florder-detail/florder-detail.model';

export const initialStateEditFlowDetail: EditFlowDetail = Object.assign({}, initialStateEditFlorderDetail, {
  flowDetail: initialStateFlowDetail,
  sort: {
    sortField:'packingId',
    sortAscending: true,
  },
  showSaldo: false,
  isDisputeMgmt: false,
  datesRange: {
    // start: '2017-07-16',
    // end: '2017-07-28'
    startDate: '',
    endDate: '',
  },
  flowDate: {
    CheckFlowDateResponse: {
      flowDate: '',
      flowWeek: {
        weekNo: null,
        year: null,
      },
      frequency: '',
    },
  },
});
